import { render, staticRenderFns } from "./sonstigeBelege.vue?vue&type=template&id=6875df11&scoped=true"
import script from "./sonstigeBelege.vue?vue&type=script&lang=ts"
export * from "./sonstigeBelege.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6875df11",
  null
  
)

export default component.exports